// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3tPkM","list":"BalanceDue_list__2KeRm","listRow":"BalanceDue_listRow__1BbRJ","total":"BalanceDue_total__25vW-"};